// extracted by mini-css-extract-plugin
export default {"box__blog":"style_box__blog__iowXA","header__box":"style_header__box__GohkB","img__bottom":"style_img__bottom__QjoZa","body__box":"style_body__box__h0P6f"};